import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon } from 'lucide-react';
export function Hero() {
  return <section id="top" className="relative w-full min-h-screen flex items-center bg-ink text-paper overflow-hidden" data-id="element-125" data-mp="ej4n3wauu9ex">
      {/* subtle texture / vignette */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(176,133,66,0.14),transparent_55%)]" data-id="element-126" data-mp="4m8lmajdinjv" />
      <div className="absolute inset-0 opacity-[0.05] bg-[url('data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 width=%2240%22 height=%2240%22><path d=%22M0 20h40M20 0v40%22 stroke=%22%23fff%22 stroke-width=%220.5%22/></svg>')]" data-id="element-127" data-mp="128fo9ew4a5tl" />

      <div className="relative mx-auto max-w-6xl px-6 py-32 grid lg:grid-cols-2 gap-16 items-center" data-id="element-128" data-mp="nc88cqrqrqk4">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-129" data-mp="3d1imxgffvoql">
          <p className="text-gold-light uppercase tracking-[0.4em] text-xs mb-6" data-id="element-130" data-mp="3814brpijjyoc">
            Independent Book Publisher
          </p>
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[1.05] mb-8" data-id="element-131" data-mp="3o7c243hhyzj9">
            Stories that endure,
            <br data-id="element-132" data-mp="39b4knaxh4c7o" />
            <span className="italic text-gold-light" data-id="element-133" data-mp="399jq3lb5st9t">wisdom that awakens.</span>
          </h1>
          <p className="text-paper/70 text-lg max-w-md leading-relaxed mb-10" data-id="element-134" data-mp="3e84nze2xv0v3">
            Deleon Publishing LLC curates thoughtful works of history, philosophy, and the spirit, crafted with the care of a bygone era, for readers of today.
          </p>
          <div className="flex flex-wrap gap-4" data-id="element-135" data-mp="2qjvaczfvpjf1">
            <a href="#catalog" className="px-8 py-3.5 bg-gold text-ink font-medium tracking-wide hover:bg-gold-light transition-colors" data-id="element-136" data-mp="2ql6e4z9bqr65">
              Explore the Catalog
            </a>
            <a href="#about" className="px-8 py-3.5 border border-white/25 text-paper hover:border-gold-light hover:text-gold-light transition-colors tracking-wide" data-id="element-137" data-mp="2hl9r122l20d7">
              Our Story
            </a>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.94
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        ease: 'easeOut',
        delay: 0.15
      }} className="hidden lg:flex justify-center" data-id="element-138" data-mp="na094yrvn3e6">
          <div className="relative" data-id="element-139" data-mp="1b0nizplcs33d">
            <div className="absolute -inset-6 bg-gold/10 blur-2xl rounded-full" data-id="element-140" data-mp="1azkvzsr5iksq" />
            <img src="https://cdn.magicpatterns.com/uploads/ockt8Bu7KApUGMMbLKsumk/KalonCover_kick.png" alt="Kalón book cover" className="relative w-72 shadow-2xl shadow-black/60 rotate-2" data-id="element-141" data-mp="161j7utevbvae" />
            <img src="https://cdn.magicpatterns.com/uploads/9a3W5kFJnjRUjkRsQVceSu/MKTCover.jpg" alt="Man, Know Thyself book cover" className="absolute -bottom-8 -left-16 w-44 shadow-2xl shadow-black/60 -rotate-6 border border-white/10" data-id="element-142" data-mp="x37am8jhxz8z" />
          </div>
        </motion.div>
      </div>

      <a href="#catalog" className="absolute bottom-8 left-1/2 -translate-x-1/2 text-paper/50 hover:text-gold-light transition-colors" aria-label="Scroll to catalog" data-id="element-143" data-mp="21aejxk2ygrc7">
        <ArrowDownIcon className="animate-bounce" size={22} data-id="element-144" data-mp="2b198iv3oc30t" />
      </a>
    </section>;
}